var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TableRow, TableCell, IconButton, Collapse, makeStyles } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import Actions from '../actions';
import { BACKGROUND_COLOR_2 } from '../../../../../../theme/colors';
import Moment from 'react-moment';
import { Children, cloneElement } from 'react';
import { DATACOLUMN, DATACOLUMNS } from '../../../../../../constants/common';
var StyledTableRow = makeStyles(function () { return ({
    root: {
        height: '44px',
        left: '119px',
        top: '230px',
        background: BACKGROUND_COLOR_2,
        border: '1px solid #E4E4F0',
        boxSizing: 'border-box',
        marginBottom: '3px'
    },
}); });
export default function Row(_a) {
    var row = _a.row, actions = _a.actions, collapsibleRow = _a.collapsibleRow, columns = _a.columns, rowClicked = _a.rowClicked, actionClicked = _a.actionClicked, children = _a.children;
    var open = false;
    var classes = StyledTableRow();
    var handleActionClicked = function (e, id) {
        e.stopPropagation();
        if (actionClicked)
            actionClicked(id);
    };
    var handleExpandClick = function (e) {
        e.stopPropagation();
        // setOpen(!open)
        return !open;
    };
    var CustomColumns = function () {
        var customColumns = [];
        //Checkcing if the children are there for data list
        if (Children) {
            Children.map(children, function (column) {
                //Checking if it finds <DataColumns> tag
                if (column.type.name == DATACOLUMNS && column.props.children) {
                    if (Array.isArray(column.props.children)) {
                        column.props.children.map(function (child) {
                            //Checking if it finds <DataColumn> tag and then pushing it childrens
                            if (child.type.name == DATACOLUMN) {
                                var entry = __assign(__assign({}, child.props.children), { key: child.key });
                                customColumns.push(entry);
                            }
                        });
                    }
                    else {
                        if (column.props.children.type.name == DATACOLUMN) {
                            var entry = __assign(__assign({}, column.props.children.props.children), { key: column.props.children.key });
                            customColumns.push(entry);
                        }
                    }
                }
            });
        }
        // check which columns are customizable
        return (React.createElement(React.Fragment, null, columns && columns.map(function (field) {
            var entry = customColumns === null || customColumns === void 0 ? void 0 : customColumns.find(function (obj) { return obj.key == field.id; });
            return (entry && field.id !== 'id' ? React.createElement(TableCell, { key: field.id }, cloneElement(entry, {
                intent: "cell",
                value: row,
            }))
                : (field.id !== 'id' &&
                    field.id !== 'actions' &&
                    React.createElement(TableCell, { key: field.id }, (field.id == 'createdOn' || field.id == 'updatedOn') ?
                        row[field.id] && React.createElement(Moment, { format: "YYYY/MM/DD HH:MM" }, row[field.id]) : row[field.id])));
        })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, { onClick: rowClicked, className: classes.root },
            collapsibleRow && React.createElement(TableCell, null,
                React.createElement(IconButton, { "aria-label": "expand row", size: "small", onClick: handleExpandClick }, open ? React.createElement(KeyboardArrowUp, null) : React.createElement(KeyboardArrowDown, null))),
            React.createElement(CustomColumns, null),
            React.createElement(TableCell, { align: "center" },
                React.createElement(Actions, { item: row, actions: actions, actionClicked: function (e, id) { return handleActionClicked(e, id); } }))),
        collapsibleRow && React.createElement(TableRow, null,
            React.createElement(TableCell, { style: { paddingBottom: 0, paddingTop: 0 }, colSpan: 6 },
                React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true }, children ? children : React.createElement("div", null))))));
}
//# sourceMappingURL=index.js.map